import { getPlatform } from 'lib/tools/getPlatform'
import Bridge from 'lib/lib/Bridge'

// 判断是不是一个函数
const isFunction = fn => fn && typeof fn === 'function'

var random = function () {
  // 生成10-12位不等的字符串
  return Math.random().toString(36).slice(2) // 截取小数点后的字符串
}

// function isFullScreen() {
//   // const { width, height, availHeight } = window.screen
//   // const rate = height / width
//   // let limit = height == availHeight ? 1.8 : 1.65 // 临界判断值
//   // return rate > limit
//   return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
// }

// http://112.124.122.87:8090/pages/viewpage.action?pageId=3311963
// http://naotu.baidu.com/file/08585fd66b8c5b2cd06c1941d1970036?token=7d10e647b44026c6
// 直接调用即可，不需要理会后续
const actionsWithoutCallback = [
  'setTitle',
  'cancelWebView',
  'allowJSControlRefresh',
  'openWebView',
  'openShareWebView',
  'dismissEditDialog',
  'showWillCallDialog',
  'callAction',
  'noticeConsultationPageReLoad',
  'isConsultIndex',
  'isPullRefreshEnable',
  'stat',
  'reloadAllWebView',
  'showMessage',
  'shake',
  'openFeedback',
  'doUpgrade',
  'getCourseDetailInfo',
  'isShowPermissionDialog',
  'setConfig',
  'checkNotificationSetting',
  'checkNotificationPermission',
  'switchTitleBar',
  'showVoiceAndVideoPermissionDialog',
  'gotoSystemPermissionSetting',
  'hideFirstConsultationOrderGuidance',
  'isShowMiniPlayer',
  'setArticleRewardInfo',
  'goToAppointmentPay',
  'launchWXMiniProgram',
  'showRecommendToDynamicDialog',
  // 脑图没有的
  'refreshCompleted',
  'setStatusBarStyle',
  'gotoConsultOrderPage',
  'gotoSearchPage',

  // 特殊的打开页面方法
  'openReadingGroupPlayPage',
  'openSearchQuestionPage',
  'gotoQuestionIndexPage',
  'switchNavigationBar'
]

// 有回调，topFunbtn，和分享特殊处理
const actionWithCallback = [
  'showEditDialog',
  'getImei',
  'checkUpgrade',
  'checkNetworkStatus',
  'getToken',
  'checkVoiceAndVideoPermission',
  'isFirstConsultationOrderGuidance',
  'downloadImage',
  'getTokenAndUserId',
  'getAudioStatus',
  'getIMUnreadMessageInfoByGroupId'
]

// 已经一些封装的话给提示建议使用
const actionTips = {
  topFuncBtnConfig: '建议和<m-header />结合，一般不需要调用',
  shareReport: '建议使用mixin wechatShare.js'
}

// 包装有回调的协议
const promiseWrap = (bridge, action, config = {}) =>
  new Promise(resolve => {
    const callbackName = `${action}Callback${random()}`
    config.callbackName = callbackName
    bridge.MethodCall({
      method: callbackName,
      callback: resolve
    })
    bridge.call(action, config)
  })

// 拓展app周期方法
const mixinCreator = (isTargerApp, bridge) => {
  let appBecomeActiveStatusEvents = {
    appShow: 'onAppShow',
    appPayDoneFail: 'onAppPayDoneFail',
    appPayDoneSuccess: 'onAppPayDoneSuccess',
    appWebviewShow: 'onAppWebviewShow',
    appWebviewHide: 'onAppWebviewHide'
  }
  return {
    created() {
      const {
        onAppGoback,
        onAppPullDownRefresh,
        onAppArticleReward,
        onAppConsultingOrderIdCallback
      } = this.$options

      // toFunbtn 已经 topFuncBtnConfig 传callback自动调
      // 注册goback，注册了默认app点击不返回
      if (isTargerApp && isFunction(onAppGoback)) {
        bridge.MethodCall({
          method: 'goBack',
          callback: onAppGoback.bind(this)
        })
      }

      // 下拉刷新，如果有定义这个方法，关闭app控制下拉刷新，并注册进window
      if (isTargerApp && isFunction(onAppPullDownRefresh)) {
        bridge.call('allowJSControlRefresh', { isAllowed: 1 })
        // 提供回调可以调用结束下啦刷新
        const finish = (option = { statusCode: 0, message: '' }) =>
          bridge.call('refreshCompleted', option)
        bridge.MethodCall({
          method: 'refreshing',
          callback: () => {
            onAppPullDownRefresh.call(this, finish)
          }
        })
      }

      // 处理appBecomeActiveStatus
      if (isTargerApp) {
        for (let key in appBecomeActiveStatusEvents) {
          const fnName = appBecomeActiveStatusEvents[key]
          if (isFunction(this.$options[fnName])) {
            window.addEventListener(key, this.$options[fnName].bind(this))
          }
        }
      }

      // 处理文章打赏
      if (isTargerApp && isFunction(onAppArticleReward)) {
        bridge.MethodCall({
          method: 'openArticleReward',
          callback: onAppArticleReward.bind(this)
        })
      }

      // 处理咨询中id返回
      if (isTargerApp && isFunction(onAppConsultingOrderIdCallback)) {
        bridge.MethodCall({
          method: 'getConsultingOrderIdCallback',
          callback: onAppConsultingOrderIdCallback.bind(this)
        })
      }
    },
    beforeDestroy() {
      for (let key in appBecomeActiveStatusEvents) {
        const fnName = appBecomeActiveStatusEvents[key]
        if (isFunction(this.$options[fnName])) {
          window.removeEventListener(key, this.$options[fnName])
        }
      }
    }
  }
}

const bridgePlugin = {
  install: Vue => {
    const { isYixinliApp, isMuseApp, isAndroid, isZiXunApp } = getPlatform()
    let isTargerApp = isYixinliApp || isMuseApp || isZiXunApp
    let bridge = new Bridge()
    bridge.AppHookInit()

    Vue.prototype.$bridge = {
      call(event, options) {
        return isTargerApp ? bridge.call(event, options) : () => {}
      },
      topFuncBtnConfig(config) {
        if (!isTargerApp) return () => {}
        console.warn(
          `topFuncBtnConfig调用提示： ${actionTips['topFuncBtnConfig']}`
        )
        // 结合callback
        if (config.btnList) {
          config.btnList = config.btnList.map(item => {
            if (typeof item.visible === 'undefined') {
              item.visible = 1
            }
            return item
          })
        }
        bridge.call('topFuncBtnConfig', config)
        bridge.MethodCall({
          method: 'topFuncBtn',
          callback: obj => {
            const target = config.btnList.find(v => v.name === obj.name)
            if (target && isFunction(target.callback)) {
              target.callback(obj)
            }
          }
        })
      },
      shareReport(config) {
        if (!isTargerApp) return () => {}
        console.warn(`shareReport调用提示： ${actionTips['shareReport']}`)
        const callbackName = `shareCallback`
        config.callbackName = callbackName
        bridge.call('shareReport', config)
        bridge.MethodCall({
          method: callbackName,
          callback: obj => {
            if (isFunction(config.success)) {
              config.success(obj)
            }
          }
        })
      }
    }

    actionWithCallback.forEach(key => {
      Vue.prototype.$bridge[key] = config => {
        return isTargerApp
          ? promiseWrap(bridge, key, config)
          : new Promise(resolve => resolve)
      }
    })

    Vue.prototype.$bridge.hasNotch = () => {
      return new Promise(resolve => {
        if (isTargerApp) {
          promiseWrap(bridge, 'hasNotch', {}).then(obj => {
            const { hasNotch, notchHeight } = obj
            obj.statusBarHeight =
              notchHeight && window.devicePixelRatio
                ? (notchHeight / window.devicePixelRatio) | 0
                : hasNotch === 1 || hasNotch === true
                ? isAndroid
                  ? 35
                  : 40
                : 20
            resolve(obj)
          })
        }
      })
    }

    actionsWithoutCallback.forEach(key => {
      Object.defineProperty(Vue.prototype.$bridge, key, {
        get() {
          if (!isTargerApp) {
            return () => {}
          }
          if (actionTips[key]) {
            console.warn(`${key}调用提示： ${actionTips[key]}`)
          }
          return bridge.call.bind(bridge, key)
        }
        // set(val) {
        //   if (!isTargerApp) {
        //     return key
        //   }
        //   bridge.MethodCall({
        //     method: key,
        //     callback: val
        //   })
        // }
      })
    })

    Vue.mixin(mixinCreator(isTargerApp, bridge))
  }
}

export default bridgePlugin
